export default __webpack_public_path__ + "b1abadd330d77f2fee6c32c8c6f4f481.png";